<template>
    <Content v-if="variations.length">
        <label>Produtos vinculados:</label>
        <!-- <ul :key="keyList">
            <li
                v-for="variation in variations"
                :key="variation.id"
                :class="{
                    active: variation.active,
                    unavailable: isUnavailable(variation)
                }"
                @click="handleSelectedVariation(variation)"
            >
                {{ variation.abbreviation }}
            </li>
        </ul> -->
    <div class="container-variation">
        <div class="scroll-container">
            <ul :key="keyList">
                <li
                    v-for="variation in variations"
                    :key="variation.id"
                    :class="{
                        active: variation.active,
                        unavailable: isUnavailable(variation)
                    }"
                    @click="handleSelectedVariation(variation)"
                >
                    <span>{{ variation.abbreviation }}</span>
                </li>
            </ul>
            <span v-if="v.variation.$error" class="required">
                * Selecione um produto
            </span>
        </div>
    </div>
    </Content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Content } from "./style";

export default {
    name: "ProductSideVariations",
    props: {
        v: {
            required: true
        }
    },
    components: {
        Content
    },
    data() {
        return {
            keyList: 0
        };
    },
    methods: {
        ...mapActions("products", ["resetActiveVariations"]),
        handleSelectedVariation(variation) {
            this.resetActiveVariations();
            variation.active = true;
            this.keyList++;
            this.$emit("selectedVariation", variation);
        },
        isUnavailable(variation) {
            let min =
                variation?.quantity_conversion_factor >
                variation.minimum_sale_quantity
                    ? variation.quantity_conversion_factor
                    : variation.minimum_sale_quantity;
            return (
                !variation.sell_out_of_stock &&
                !variation.price_on_request &&
                variation.out_of_stock_unavailable &&
                this.company?.finalizacao_pagamento?.tipo === "PAGAMENTO" &&
                (variation.pro_stock_site < 1 || variation.pro_stock_site < min)
            );
        }
    },
    watch: {
        reset(reset) {
            if (reset) {
                this.resetActiveVariations();
                this.$emit("selectedVariation", null);
                this.keyList++;
            }
        }
    },
    computed: {
        ...mapState("company", ["company"]),
        ...mapState("products", ["variations", "reset"])
    }
};
</script>
